/* eslint-disable import/max-dependencies */
import { LazyMotion } from "framer-motion";
import Head from "next/head";
import { appWithTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import "react-18-image-lightbox/style.css";
import "react-lazy-load-image-component/src/effects/black-and-white.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-lazy-load-image-component/src/effects/opacity.css";
import "simplebar-react/dist/simplebar.min.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
// import { MotionLazyContainer } from "@larvitu/shared/framer-motion/utils";
import { MuiTheme } from "@larvitu/shared/mui/feature-theme-provider";
import { ProgressBar } from "@larvitu/shared/mui/ui-components";

import nextI18NextConfig from "../../next-i18next.config";

import { domAnimation } from 'framer-motion';

import "../styles/globals.css";
import { theme } from "../theme";

import type { UserConfig } from "next-i18next";
import type React from "react";
import type { ReactElement } from "react";

// import { _api } from '@iconify/svelte';
import { _api } from "@iconify/react";
import fetch from "cross-fetch";

import { font } from "../styles/fonts";

import { CssBaseline } from "@mui/material";
//  import fetch from 'node-fetch';

// Set Fetch API before doing anything
_api.setFetch(fetch);

const MyApp = ({
  Component,
  pageProps: { ...pageProps },
}: {
  pageProps: Record<string, unknown>;
  Component: React.ComponentType & {getLayout?: (page: ReactElement) => ReactElement};
}): React.JSX.Element => {
  const getLayout = Component.getLayout ?? ((page: ReactElement): ReactElement => page);

  return (
    <>
      <Head>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
        <title>App</title>
        <style global jsx>
          {`html {
            font-family: ${font.style.fontFamily};
        }`}
        </style>
      </Head>
      <MuiTheme.Provider theme={theme} responsiveFontSizes>
        <CssBaseline />

        <LazyMotion strict features={domAnimation} >
        {/*<MotionLazyContainer>*/}
          <ProgressBar />
          {getLayout(<Component {...pageProps} />)}
        {/*</MotionLazyContainer>*/}
        </LazyMotion>
      </MuiTheme.Provider>
    </>
  );
};

// console.log({ nextI18NextConfig });

export default appWithTranslation(MyApp, nextI18NextConfig as UserConfig);
// export default appWithTranslation(MyApp);
// export default MyApp;
